/**
 * Where the marketing site sends people OUT of the marketing site (DIT-399).
 *
 * Every CTA used to carry the literal `https://stage.done-it.app/en/plan`,
 * repeated at 16 call sites. That dropped the visitor's locale (a Dutch or
 * Belgian-French reader landed on the English funnel), dropped the market
 * (Belgium visitors got the international price list, i.e. USD), and — being an
 * absolute staging URL — would have sent PRODUCTION visitors to the staging
 * domain after the prod domain cutover.
 *
 * `TRIAL_PATH` is therefore RELATIVE. Route it through `LocaleLink` or the DS
 * `Button` (whose relative `to` renders a `LocaleLink`) and the active locale
 * prefix is applied automatically, so `/plan` becomes `/nl/plan` for a Dutch
 * reader — same origin, same market, no hardcoded environment.
 */
export const TRIAL_PATH = '/plan';

/**
 * Dashboard login — a genuinely different host, so it stays absolute, but it is
 * read from the environment rather than baked in.
 *
 * Kept in lockstep with `src/shared/config/links.ts`, which resolves the same
 * `VITE_DASHBOARD_URL` for the funnel. The two are deliberately separate modules
 * (`src/marketing/**` is vendored from done-it-design and must not import
 * landing-specific paths), but they read the same variable, so a deployed
 * environment cannot make them disagree.
 *
 * The fallback is prod for the reason spelled out in that file: it used to be
 * staging, and an unset variable therefore pointed a production build at the
 * staging dashboard with nothing on the page to show it.
 */
const DASHBOARD_URL = (
  import.meta.env.VITE_DASHBOARD_URL || 'https://dashboard.done-it.app'
).replace(/\/+$/, '');

export const LOGIN_URL = `${DASHBOARD_URL}/login`;
